// extracted by mini-css-extract-plugin
export default {"container":"KXBQij8oQhfXENOvq4x1"};